import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Subscription from "@/components/site/Subscription";
import Portfolio from "@/components/site/Portfolio";
import Process from "@/components/site/Process";
import About from "@/components/site/About";
import FounderOffer from "@/components/site/FounderOffer";
import FAQ from "@/components/site/FAQ";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";
import SectionDivider from "@/components/site/SectionDivider";
import {
  CTAAfterPortfolio,
  CTAAfterMethod,
  StickyMobileCTA,
} from "@/components/site/CTACheckpoints";

export default function Home() {
  return (
    <main id="main" data-testid="home-page" className="relative">
      {/* Skip to content for screen readers / keyboard users */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:rounded-full focus:bg-[#0B1027] focus:text-white focus:text-sm focus:font-medium focus:shadow-tactile-lg"
      >
        Aller au contenu principal
      </a>
      <Navigation />
      <div id="main-content" />
      <Hero />
      <SectionDivider />
      <Services />
      <Subscription />
      <Portfolio />
      <CTAAfterPortfolio />
      <SectionDivider />
      <Process />
      <CTAAfterMethod />
      <SectionDivider />
      <About />
      <SectionDivider />
      <FounderOffer />
      <Booking />
      <SectionDivider />
      <FAQ />
      <Footer />
      <StickyMobileCTA />
    </main>
  );
}
